// localStorage pode falhar (aba anônima, cota, bloqueio). Toda leitura e
// escrita passa por aqui e falha em silêncio.

export function readJson<T>(key: string): T | null {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function writeJson(key: string, value: unknown): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* sem armazenamento: segue sem salvar */
  }
}

export function removeKey(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* idem */
  }
}

export const SAVE_KEY = 'estandarte.save.v1';
export const SETTINGS_KEY = 'estandarte.settings.v1';
export const SESSION_KEY = 'estandarte.session.v1';
